import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import NutritionModalRow from './components/NutritionModalRow';
import useItemNutrition from './hooks/useItemNutrition';

interface Params {
    itemId: string;
}

declare module '@stackflow/config' {
    interface Register {
        ItemNutritionModal: Params;
    }
}

const ItemNutritionModal: ActivityComponentType<'ItemNutritionModal'> = ({ params }) => {
    const { itemId } = params;
    const { nutrition, isNutritionExists } = useItemNutrition(itemId);
    const { t } = useTranslation('item');
    return (
        <AppScreen>
            <CtaLayout header={
                <Header title='' />
            }>
                <Container fullWidth spacing={12}>
                    {(!isNutritionExists) && (
                        <Row fullWidth justify='center'>
                            <Text color={colors.gray6}>{t('nutrition.noData')}</Text>
                        </Row>
                    )}
                    {nutrition?.allergyComment && (
                        <Column spacing={2}>
                            <Text fontWeight='bold'>{t('nutrition.allergy')}</Text>
                            <Text color={colors.gray7}>{nutrition?.allergyComment}</Text>
                        </Column>
                    )}
                    <Column fullWidth spacing={2}>
                        <Text fontWeight='bold'>{t('nutrition.title')}</Text>
                        <NutritionModalRow labelKey='servingSize' value={nutrition?.servingSize} />
                        <NutritionModalRow labelKey='calories' value={nutrition?.calories}/>
                        <NutritionModalRow labelKey='sodium' value={nutrition?.sodium}/>
                        <NutritionModalRow labelKey='sugar' value={nutrition?.sugar}/>
                        <NutritionModalRow labelKey='saturatedFat' value={nutrition?.saturatedFat}/>
                        <NutritionModalRow labelKey='protein' value={nutrition?.protein}/>
                        <NutritionModalRow labelKey='caffeine' value={nutrition?.caffeine}/>
                        <NutritionModalRow labelKey='carbohydrate' value={nutrition?.carbohydrate}/>
                        <NutritionModalRow labelKey='fat' value={nutrition?.fat}/>
                        <NutritionModalRow labelKey='cholesterol' value={nutrition?.cholesterol}/>
                        <NutritionModalRow labelKey='transFat' value={nutrition?.transFat}/>
                        <NutritionModalRow labelKey='origin' value={nutrition?.origin}/>
                    </Column>
                </Container>
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 24px 16px;
`;

export default ItemNutritionModal;
